import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';

export interface TagsProps {
  tags: string[];
}

export const Tags = (props: TagsProps) => {
  return props.tags && props.tags.length > 0 ? (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{Messages.tags()}</span>
      <span className={DetailsTooltipStyles.MetadataValue}>
        { props.tags.join(', ') }
      </span>
    </div>
  ) : null;
};
